import useSyncedMedia from './useSyncedMedia';
import TrimmedVideoPlayer from '../presentation-editor/TrimmedVideoPlayer';

const SyncedVideo = ({
  elementId,
  src,
  className,
  isTeacher,
  lessonSessionId,
  initialMuted,
  loop,
  autoPlay,
  trimStart,
  trimEnd
}) => {
  const { mediaRef, teacherProps } = useSyncedMedia({ elementId, isTeacher, lessonSessionId });

  const safeStart = Math.max(0, Number(trimStart) || 0);
  const trimEndNum = Number(trimEnd);
  const safeEnd = Number.isFinite(trimEndNum) && trimEndNum > safeStart ? trimEndNum : null;
  const hasTrim = safeStart > 0 || safeEnd !== null;

  if (hasTrim) {
    return (
      <TrimmedVideoPlayer
        ref={mediaRef}
        src={src}
        trimStart={safeStart}
        trimEnd={safeEnd}
        muted={isTeacher ? !!initialMuted : false}
        loop={loop}
        autoPlay={isTeacher ? autoPlay : false}
        videoClassName={className}
        showControls={isTeacher}
        videoProps={isTeacher ? teacherProps : {}}
      />
    );
  }

  if (!isTeacher) {
    return (
      <video
        ref={mediaRef}
        src={src}
        className={className}
        playsInline
        loop={loop}
        onContextMenu={(e) => e.preventDefault()}
      />
    );
  }

  return (
    <video
      ref={mediaRef}
      src={src}
      className={className}
      controls
      controlsList="nodownload"
      playsInline
      muted={initialMuted}
      loop={loop}
      autoPlay={autoPlay}
      onContextMenu={(e) => e.preventDefault()}
      {...teacherProps}
    />
  );
};

export default SyncedVideo;
